import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Swal from 'sweetalert2';
import {
    TableContainer, Paper, TablePagination,
    Button, Typography, IconButton, Dialog, DialogActions, DialogContent, DialogTitle, TextField,
    Select, MenuItem, FormControl, Checkbox,
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { Delete, RemoveRedEye } from '@mui/icons-material';
import { useApis, FarmerByFPO } from '../../Api_url';
import { MaterialReactTable } from 'material-react-table';
import { Add } from '@mui/icons-material';
import * as XLSX from 'xlsx';
import { AddFarmerCsv } from '../../Api_url'
import img from '../../../assets/Group 100.png'

const FarmersInformation = () => {
    const { postJson, getJson } = useApis()
    const [farmersData, setFarmersData] = useState([]);  // Farmers data state
    const [page, setPage] = useState(0);  // Page state
    const [rowsPerPage, setRowsPerPage] = useState(10);  // Rows per page state
    const [totalCount, setTotalCount] = useState();  // Total count of farmers for pagination
    const [error, setError] = useState(null);  // Error state
    const [selectedFarmers, setSelectedFarmers] = useState([]);  // Track selected farmers
    const [openDialog, setOpenDialog] = useState(false);  // Dialog state
    const [farmerName, setFarmerName] = useState('');  // Farmer name state for new farmer
    const [farmerMobile, setFarmerMobile] = useState('');  // Farmer mobile state for new farmer
    const [farmerVillage, setFarmerVillage] = useState('');  // Farmer district state for new farmer
    const [openModal, setOpenModal] = useState(false)
    const [dialogError, setDialogError] = useState(null);
    const [farmerGender, setFarmerGender] = useState('');  // Gender state for new farmer
    const [file, setFile] = useState(null)
    const [loading, setLoading] = useState(false)

    const [success, setSuccess] = useState(null)
    const navigate = useNavigate();

    // Fetch Farmers Data with Pagination
    const fetchFarmersData = async (p) => {
        const accessToken = localStorage.getItem('access_token');
        if (!accessToken) {
            setError('No access token found.');
            return;
        }

        try {
            const response = await getJson('GetAllFarmerbyFPO', {
                page: p + 1,  // API uses 1-based pagination
                per_page: rowsPerPage,
            })

            const data = response?.data?.results || [];
            const count = response?.data?.count || 0;

            console.log("Fetched farmers data:", data);  // Debugging log
            setFarmersData(data);
            setTotalCount(count);  // Set total farmer count for pagination
        } catch (error) {
            console.error('Error fetching member data:', error);
            setError('Error fetching data.');
        }
    };

    const handleChangePage = (event, newPage) => {
        setPage(newPage);  // Update page when the user changes the page
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));  // Update rows per page when changed
        setPage(0);  // Reset to the first page when rows per page changes
    };

    const downloadSampleExcel = () => {
        const sampleData = [
            ["mobile_number", "name", "village", "gender", "block"],
            ["0000000000", "XYZ", "XYZ", "Male", "A"],
        ];
        const ws = XLSX.utils.aoa_to_sheet(sampleData);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'Members');
        XLSX.writeFile(wb, 'sample_member.xlsx');
    }

    const handleFileChange = (e) => {
        setFile(e.target.files[0])
    }

    // Handle file upload
    const handleUpload = async () => {
        if (!file) {
            Swal.fire({
                icon: 'warning',
                title: 'No File Selected',
                text: 'Please select a file to upload.',
                confirmButtonText: 'OK',
                didOpen: () => {
                    const swalElement = document.querySelector('.swal2-container');
                    if (swalElement) {
                        swalElement.style.zIndex = 1500;
                    }
                }
            });
            return;
        }

        const formData = new FormData();
        formData?.append('csv_file', file);

        try {
            setLoading(true);
            setError(null);
            setSuccess(null);

            const token = localStorage.getItem('access_token');
            const response = await axios.post(
                AddFarmerCsv,
                formData,
                {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                        Authorization: `Bearer ${token}`,
                    },
                }
            );

            if (response?.status === 200) {
                if (response?.data?.errors_count > 0) {
                    let errorMessages = [];
                    if (Array.isArray(response?.data?.errors)) {
                        errorMessages = response?.data?.errors;
                    } else if (typeof response?.data?.errors === 'object') {
                        errorMessages = [JSON.stringify(response?.data?.errors)];
                    } else {
                        errorMessages = ['An unknown error occurred.'];
                    }

                    Swal.fire({
                        icon: 'error',
                        title: 'File Upload Failed',
                        html: errorMessages.map((error, index) => `<div key=${index} class="text-red-500">${error}</div>`).join(''),
                        didOpen: () => {
                            const swalElement = document.querySelector('.swal2-container');
                            if (swalElement) {
                                swalElement.style.zIndex = 1500;
                            }
                        }
                    });
                } else {
                    Swal.fire({
                        icon: 'success',
                        title: 'File Uploaded Successfully',
                        text: 'Your file has been uploaded successfully.',
                        didOpen: () => {
                            const swalElement = document.querySelector('.swal2-container');
                            if (swalElement) {
                                swalElement.style.zIndex = 1500;
                            }
                        }
                    }).then(() => {
                        setOpenModal(false);
                    });
                }
            } else {
                setError('Something went wrong, please try again later.');
            }
        } catch (err) {
            console.error('Upload error:', err);
            setError('Only excel file is supported, please upload excel file.');
        } finally {
            setLoading(false);
        }
    };


    useEffect(() => {
        fetchFarmersData(page);  // Fetch farmers data whenever the page or rowsPerPage changes
    }, [page, rowsPerPage]);

    // Handle row click to navigate to farmer details
    const handleRowClick = (farmerId) => {
        navigate(`/memberdetail/${farmerId}`);
    };

    // Handle selection of a checkbox
    const handleSelectFarmer = (farmerId) => {
        setSelectedFarmers(prevState => {
            if (prevState.includes(farmerId)) {
                return prevState?.filter(id => id !== farmerId);  // Unselect farmer if already selected
            } else {
                return [...prevState, farmerId];  // Select farmer
            }
        });
    };

    // Handle bulk deletion
    const handleBulkDelete = async () => {
        if (selectedFarmers?.length === 0) {
            Swal.fire({
                title: 'Error!',
                text: 'No Members selected for deletion.',
                icon: 'error',
                confirmButtonText: 'OK',
            });
            return;
        }

        const accessToken = localStorage.getItem('access_token');
        if (!accessToken) {
            Swal.fire({
                title: 'Error!',
                text: 'No access token found.',
                icon: 'error',
                confirmButtonText: 'OK',
            });
            return;
        }

        try {
            const response = await axios.delete(FarmerByFPO, {
                headers: {
                    'Authorization': `Bearer ${accessToken}`,
                },
                data: {
                    farmer_id: selectedFarmers,  // Send selected farmer IDs for deletion
                },
            });

            if (response?.data?.status === 'success') {
                Swal.fire({
                    title: 'Success!',
                    text: response.data.message || 'Members deleted successfully!',
                    icon: 'success',
                    timer: 2000,
                    showConfirmButton: false,
                });
                fetchFarmersData(page); // Refetch data after successful deletion
                setSelectedFarmers([]);  // Clear the selected farmers list
            } else {
                Swal.fire({
                    title: 'Error!',
                    text: response.data.message || 'Failed to delete member.',
                    icon: 'error',
                    confirmButtonText: 'OK',
                });
            }
        } catch (error) {
            Swal.fire({
                title: 'Error!',
                text: error.response?.data?.message || 'An error occurred during deletion.',
                icon: 'error',
                confirmButtonText: 'OK',
            });
        }
    };

    const handleSubmit = async () => {
        if (!farmerName || !farmerMobile || !farmerVillage) {
            setDialogError('Please fill in all fields.');
            return;
        }

        const phonePattern = /^[0-9]{10}$/;
        if (!phonePattern.test(farmerMobile)) {
            setDialogError('Please enter a valid mobile number.');
            return;
        }

        try {
            const response = await postJson('FarmerByFPO', {
                farmer_name: farmerName,
                farmer_mobile: farmerMobile,
                farmer_village: farmerVillage,
                farmer_gender: farmerGender,
            })

            if (response?.status === 201) {
                Swal.fire({
                    title: 'Success!',
                    text: 'Farmer added successfully!',
                    icon: 'success',
                    timer: 2000,
                    showConfirmButton: false,
                    didOpen: () => {
                        const swalElement = document.querySelector('.swal2-container');
                        if (swalElement) {
                            swalElement.style.zIndex = 1500;
                        }
                    }
                });

                // Add the newly added farmer to the farmersData list
                const newFarmer = {
                    id: response?.results?.farmer_id,  // Assuming the response contains the new farmer's ID
                    name: farmerName,
                    mobile: farmerMobile,
                    village: farmerVillage,
                    gender: farmerGender,
                };
                setFarmersData(prevFarmersData => [newFarmer, ...prevFarmersData]);

                setOpenDialog(false);
                fetchFarmersData(page);
            } else {
                setOpenDialog(false);
                Swal.fire({
                    title: 'Error!',
                    text: response.data.message || 'Failed to add farmer.',
                    icon: 'error',
                    confirmButtonText: 'OK',
                    didOpen: () => {
                        const swalElement = document.querySelector('.swal2-container');
                        if (swalElement) {
                            swalElement.style.zIndex = 1500;
                        }
                    }
                });
            }
        } catch (error) {
            console.log(error);

            if (error?.response?.data?.message === "Mobile number already exists") {
                setDialogError("Mobile number already exists")
            }
        }
    };

    const columns = [
        {
            header: 'Select',
            id: 'select',
            Cell: ({ row }) => (
                <Checkbox
                    checked={selectedFarmers.includes(row.original.id)}
                    onChange={() => handleSelectFarmer(row.original.id)}
                />
            ),
            size: 50,
        },
        {
            header: 'S.No',
            id: 'serial',
            accessorKey: 'id',
            Cell: ({ row }) => row.index + 1,
            size: 50,
        },
        {
            header: 'Name',
            id: 'name',
            accessorKey: 'name',
            size: 50,
        },
        {
            header: 'Mobile',
            id: 'mobile',
            accessorKey: 'mobile',
            size: 50,
        },
        {
            header: 'Action',
            id: 'action',
            Cell: ({ row }) => (
                <IconButton onClick={() => handleRowClick(row.original.id)}>
                    <RemoveRedEye />
                </IconButton>
            ),
            size: 50,
        },
    ];

    return (
        <div className="p-6">
            {error && <Typography color="error">{error}</Typography>}

            {farmersData.length != 0 ? (
                <div className="flex flex-col md:flex-row items-center gap-4">
                    <Button
                        variant="contained"
                        onClick={() => setOpenDialog(true)}
                        startIcon={<Add />}
                        sx={{
                            textTransform: 'none',
                            borderRadius: 2,
                            paddingX: 4,
                            color: 'white',
                            width: 'fit-content',
                            alignSelf: 'center',
                        }}
                    >
                        Add Member
                    </Button>

                    <Button
                        variant="contained"
                        color='secondary'
                        onClick={() => setOpenModal(true)}
                        startIcon={<Add />}
                        sx={{
                            textTransform: 'none',
                            borderRadius: 2,
                            paddingX: 4,
                            color: 'white',
                            width: 'fit-content',
                            alignSelf: 'center',
                        }}
                    >
                        Upload Excel
                    </Button>

                    <IconButton
                        onClick={handleBulkDelete}
                        disabled={selectedFarmers.length === 0}
                        sx={{
                            borderRadius: 2,
                            backgroundColor: 'red', // Red background
                            color: 'white', // White color for the icon
                            '&:hover': {
                                backgroundColor: 'red', // Darker red on hover
                            },
                            '&:disabled': {
                                backgroundColor: '#d3d3d3',
                                color: '#a9a9a9',
                            },
                        }}
                    >
                        <Delete />
                    </IconButton>

                </div>
            ) : null}
            
            {farmersData.length === 0 ?
                <div className="flex flex-col items-center mt-28">
                    {/* Image when no data is available */}
                    <img src={img} alt="No data" className="mb-4" />

                    {/* Buttons below the image */}
                    <div className="flex flex-col md:flex-row items-center gap-4">
                        <Button
                            variant="contained"
                            onClick={() => setOpenDialog(true)}
                            startIcon={<Add />}
                            sx={{
                                textTransform: 'none',
                                borderRadius: 2,

                                paddingX: 4,
                                color: 'white',
                                width: 'fit-content',
                                alignSelf: 'center',
                                mt: 10
                            }}
                        >
                            Add Member
                        </Button>

                        <Button
                            variant="contained"
                            color='secondary'
                            onClick={() => setOpenModal(true)}
                            startIcon={<Add />}
                            sx={{
                                textTransform: 'none',
                                borderRadius: 2,

                                paddingX: 4,
                                color: 'white',
                                width: 'fit-content',
                                alignSelf: 'center',
                                mt: 10

                            }}
                        >
                            Upload Excel
                        </Button>
                    </div>
                </div> :
                <div style={{ maxWidth: '100%', overflowY: 'auto', padding: 10 }}>
                    <TableContainer component={Paper} className="overflow-x-auto mt-6 relative">
                        {/* MaterialReactTable with disabled internal pagination */}
                        <MaterialReactTable
                            columns={columns}
                            data={farmersData}
                            enablePagination={false}
                            muiTableHeadCellProps={{
                                sx: {
                                    borderBottom: "none",
                                },
                            }}
                            muiTableBodyCellProps={{
                                sx: {
                                    borderBottom: "none",
                                },
                            }}
                        />
                        {/* Pagination Component */}
                        <div className="absolute bottom-0 left-0 right-0 z-10 bg-white">
                            <TablePagination
                                rowsPerPageOptions={[5, 10, 25]} // Adjust row options
                                component="div"
                                count={totalCount}  // Total number of rows in your data
                                rowsPerPage={rowsPerPage}  // Rows per page
                                page={page}  // Current page
                                onPageChange={handleChangePage}  // Handle page change
                                onRowsPerPageChange={handleChangeRowsPerPage}  // Handle rows per page change
                                nextButtonProps={{ disabled: page * rowsPerPage + rowsPerPage >= totalCount }}  // Disable next button if no next page
                                backButtonProps={{ disabled: page === 0 }}  // Disable back button if at the first page
                            />
                        </div>
                    </TableContainer>
                </div>
            }

            <Dialog
                open={openDialog}
                onClose={() => setOpenDialog(false)}
                sx={{
                    '& .MuiDialog-paper': {
                        width: '60%',
                        maxWidth: '60%',
                        height: '70%',
                        maxHeight: '70%',
                        margin: 'auto',
                        padding: '20px',
                        borderRadius: 4,
                        boxShadow: '0px 0px 5px rgba(0, 0, 0, 0.1)',
                        overflow: 'auto',
                        backgroundColor: '#F2F2F2'
                    },
                }}
            >
                {/* Header with Cancel/Submit */}
                <div className="flex justify-between items-center px-6 pt-2 ">
                    <button
                        onClick={() => setOpenDialog(false)}
                        className="text-gray-500 hover:text-gray-700"
                    >
                        Cancel
                    </button>
                    <button
                        onClick={handleSubmit}
                        className="text-green-500 hover:text-green-600 font-medium"
                    >
                        Submit
                    </button>
                </div>

                {/* Title */}
                <DialogTitle
                    className="text-center text-xl font-medium pb-4"
                >
                    Add Members
                </DialogTitle>

                <DialogContent>
                    <div className="space-y-4 ">
                        {/* Name Field */}
                        <div>
                            <label className="block text-gray-500 mb-2">Name</label>
                            <TextField
                                fullWidth
                                value={farmerName}
                                onChange={(e) => setFarmerName(e.target.value)}
                                required
                                variant="outlined"
                                InputProps={{
                                    style: {
                                        backgroundColor: '#fff',
                                        borderRadius: '8px',
                                        borderColor: '#F2F2F2',  // Default border color
                                    },
                                }}
                                sx={{
                                    '& .MuiOutlinedInput-root': {
                                        '& fieldset': {
                                            borderColor: '#F2F2F2',  // Default border color
                                        },
                                        '&:hover fieldset': {
                                            borderColor: '#F2F2F2',  // Hover state border color
                                        },
                                        '&.Mui-focused fieldset': {
                                            borderColor: '#F2F2F2',  // Focus state border color
                                        },
                                    },
                                    '& .MuiOutlinedInput-input': {
                                        padding: '10px 14px',
                                        borderColor: '#F2F2F2',  // Ensuring no color is applied directly here
                                    },
                                }}
                            />
                        </div>


                        {/* Mobile Field */}
                        <div>
                            <label className="block text-gray-500 mb-2">Mobile</label>
                            <TextField
                                fullWidth
                                value={farmerMobile}
                                onChange={(e) => setFarmerMobile(e.target.value)}
                                required
                                // placeholder="Enter mobile number"
                                variant="outlined"
                                InputProps={{
                                    style: {
                                        borderRadius: '8px',
                                        backgroundColor: '#fff',
                                        borderColor: '#F2F2F2',
                                    }
                                }}
                                sx={{
                                    '& .MuiOutlinedInput-root': {
                                        '& fieldset': {
                                            borderColor: '#F2F2F2',  // Default border color
                                        },
                                        '&:hover fieldset': {
                                            borderColor: '#F2F2F2',  // Hover state border color
                                        },
                                        '&.Mui-focused fieldset': {
                                            borderColor: '#F2F2F2',  // Focus state border color
                                        },
                                    },
                                    '& .MuiOutlinedInput-input': {
                                        padding: '10px 14px',
                                        borderColor: '#F2F2F2',  // Ensuring no color is applied directly here
                                    },
                                }}
                            />
                        </div>

                        {/* Village Field */}
                        <div>
                            <label className="block text-gray-500 mb-2">Village</label>
                            <TextField
                                fullWidth
                                value={farmerVillage}
                                onChange={(e) => setFarmerVillage(e.target.value)}
                                required

                                variant="outlined"
                                InputProps={{
                                    style: {
                                        borderRadius: '8px',
                                        backgroundColor: '#fff',
                                        borderColor: '#F2F2F2',
                                    }
                                }}
                                sx={{
                                    '& .MuiOutlinedInput-root': {
                                        '& fieldset': {
                                            borderColor: '#F2F2F2',  // Default border color
                                        },
                                        '&:hover fieldset': {
                                            borderColor: '#F2F2F2',  // Hover state border color
                                        },
                                        '&.Mui-focused fieldset': {
                                            borderColor: '#F2F2F2',  // Focus state border color
                                        },
                                    },
                                    '& .MuiOutlinedInput-input': {
                                        padding: '10px 14px',
                                        borderColor: '#F2F2F2',  // Ensuring no color is applied directly here
                                    },
                                }}
                            />
                        </div>

                        {/* Gender Field */}
                        <div>
                            <label className="block text-gray-500 mb-2">Gender (optional)</label>
                            <FormControl fullWidth>
                                <Select
                                    value={farmerGender}
                                    onChange={(e) => setFarmerGender(e.target.value)}
                                    displayEmpty
                                    variant="outlined"
                                    sx={{
                                        backgroundColor: '#fff',
                                        '& .MuiOutlinedInput-root': {
                                            '& fieldset': {
                                                borderColor: '#F2F2F2',  // Default border color
                                            },
                                            '&:hover fieldset': {
                                                borderColor: '#F2F2F2',  // Hover state border color
                                            },
                                            '&.Mui-focused fieldset': {
                                                borderColor: '#F2F2F2',  // Focus state border color (override blue)
                                                borderWidth: '1px', // Ensure border width is applied
                                                boxShadow: 'none',  // Remove the default blue box shadow
                                            },
                                        },
                                        '& .MuiOutlinedInput-input': {
                                            padding: '10px 14px',
                                        },
                                    }}
                                >
                                    {/* <MenuItem value="">Select gender</MenuItem> */}
                                    <MenuItem value="Male">Male</MenuItem>
                                    <MenuItem value="Female">Female</MenuItem>
                                    <MenuItem value="Others">Others</MenuItem>
                                </Select>
                            </FormControl>
                        </div>


                        {/* Error Message */}
                        {dialogError && (
                            <Typography color="error" className="mt-2">
                                {dialogError}
                            </Typography>
                        )}
                    </div>
                </DialogContent>
            </Dialog>

            <Dialog open={openModal} onClose={() => setOpenModal(false)} maxWidth="sm" >
                <DialogContent className="space-y-4">
                    {/* Flex container in column direction for all screen sizes */}
                    <div className="flex flex-col space-y-4">
                        <button
                            onClick={downloadSampleExcel}
                            className="bg-green-500 text-white py-2 px-4 rounded-lg hover:bg-green-600 transition w-full"
                        >
                            Download Sample Excel
                        </button>

                        <DialogTitle className="text-center text-xl font-semibold">
                            Upload Excel File
                        </DialogTitle>

                        <input
                            type="file"
                            accept=".xlsx, .xls"
                            onChange={handleFileChange}
                            className="py-2 px-4 border border-gray-300 rounded-lg w-full"
                        />
                    </div>

                    {error && <p className="text-red-500">{error}</p>}
                    {success && <p className="text-green-500">{success}</p>}
                </DialogContent>

                <DialogActions>
                    <button
                        onClick={handleUpload}
                        style={{ zIndex: 10 }}
                        className="bg-blue-500 text-white py-2 px-4 rounded-lg hover:bg-blue-600 transition w-full"
                        disabled={loading}
                    >
                        {loading ? 'Uploading...' : 'Upload Excel'}
                    </button>
                </DialogActions>
            </Dialog>
        </div>
    );
};

export default FarmersInformation;
